import { DatePicker } from "antd";
import React from "react";
import "./DefaultInput.css";

interface IDefaultDatePicker {
	label?: string;
	width?: number;
	placeholder?: string;
	value?: any;
	onChange?: (value: any) => void;
	className?: any;
	showTime?: boolean;
}

const DefaultDatePicker = ({
	label,
	width,
	placeholder,
	value,
	onChange,
	className,
	showTime = false,
}: IDefaultDatePicker) => {
	return (
		<div className="flex flex-col">
			<p>{label}</p>
			<DatePicker
				style={{ width: width ? width : 250 }}
				size={"large"}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				className={`default-input ${className}`}
				showTime={showTime}
			/>
		</div>
	);
};

export default DefaultDatePicker;
